"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIConfiguration = exports.UIConfigurationBannerIntoModal = exports.UIConfigurationModalOnly = exports.UIConfigurationBannerOnly = exports.SecondLayerConfig = exports.FirstLayerConfig = exports.CommonLayerConfig = exports.FooterConfig = exports.ModalButtonConfig = exports.ButtonConfig = exports.SharedTopLevelConfig = exports.AbsoluteUrlString = exports.ButtonType = exports.ButtonAction = exports.ModalButtonActions = void 0;
const t = __importStar(require("io-ts"));
const internationalization_1 = require("@transcend-io/internationalization");
const type_utils_1 = require("@transcend-io/type-utils");
/** Actions for buttons in modals */
exports.ModalButtonActions = (0, type_utils_1.makeEnum)({
    SaveAndClose: 'SaveAndClose',
    AcceptAllAndClose: 'AcceptAllAndClose',
    RejectAllAndClose: 'RejectAllAndClose',
});
/** All action types for buttons */
exports.ButtonAction = (0, type_utils_1.makeEnum)({
    ...exports.ModalButtonActions,
    OpenModal: 'OpenModal',
});
/** Button Type */
exports.ButtonType = (0, type_utils_1.makeEnum)({
    Default: 'default',
    Link: 'link',
});
/** Absolute URL string */
exports.AbsoluteUrlString = t.string;
/** Top-level configuration shared between the UI layers */
exports.SharedTopLevelConfig = t.type({
    /** Supported locales */
    locales: t.array((0, type_utils_1.valuesOf)(internationalization_1.LOCALE_KEY)),
    /** The transcend URL where the transcend logo links to */
    transcendUrl: exports.AbsoluteUrlString,
    /** The default language to use - must be one of the supported locales */
    defaultLanguage: (0, type_utils_1.valuesOf)(internationalization_1.LOCALE_KEY),
});
/** Button configuration */
exports.ButtonConfig = t.type({
    type: (0, type_utils_1.valuesOf)(exports.ButtonType),
    action: (0, type_utils_1.valuesOf)(exports.ButtonAction),
});
/** Configuration for buttons in modals */
exports.ModalButtonConfig = t.type({
    type: (0, type_utils_1.valuesOf)(exports.ButtonType),
    action: (0, type_utils_1.valuesOf)(exports.ModalButtonActions),
});
/** Footer configuration */
exports.FooterConfig = t.type({
    showTranscendBadge: t.boolean,
    showGpcDetected: t.boolean,
    showLocalePicker: t.boolean,
});
/** Common configuration for both first and second layers */
exports.CommonLayerConfig = t.intersection([
    t.type({
        showCloseButton: t.boolean,
    }),
    t.partial({
        logoImageUrl: exports.AbsoluteUrlString,
        alphaMask: t.boolean,
        showLanguagePicker: t.boolean,
        footer: exports.FooterConfig,
        links: t.array(exports.AbsoluteUrlString),
    }),
]);
/** First layer configuration: Banner */
exports.FirstLayerConfig = t.intersection([
    exports.CommonLayerConfig,
    t.type({
        buttons: t.tuple([
            exports.ButtonConfig,
            t.union([exports.ButtonConfig, t.undefined]),
            t.union([exports.ButtonConfig, t.undefined]),
        ]),
    }),
    t.partial({
        showHeader: t.boolean,
    }),
]);
/** Second layer configuration: Modal */
exports.SecondLayerConfig = t.intersection([
    exports.CommonLayerConfig,
    t.type({
        buttons: t.tuple([
            exports.ModalButtonConfig,
            t.union([exports.ModalButtonConfig, t.undefined]),
            t.union([exports.ModalButtonConfig, t.undefined]),
        ]),
        showBulkActions: t.boolean,
        closeAfterBulkAction: t.boolean,
        showPurposeDescriptions: t.boolean,
        showCookiesLink: t.literal(false),
        showVendorsLink: t.literal(false),
        showToggleText: t.boolean,
        showToggleIcon: t.boolean,
    }),
]);
/** --- Top-level UI Configuration --- */
/** Banner only configuration */
exports.UIConfigurationBannerOnly = t.intersection([
    exports.SharedTopLevelConfig,
    t.type({
        firstLayerConfig: exports.FirstLayerConfig,
    }),
]);
/** Modal only configuration */
exports.UIConfigurationModalOnly = t.intersection([
    exports.SharedTopLevelConfig,
    t.type({
        secondLayerConfig: exports.SecondLayerConfig,
    }),
]);
/** Banner into modal configuration */
exports.UIConfigurationBannerIntoModal = t.intersection([
    exports.SharedTopLevelConfig,
    t.type({
        firstLayerConfig: exports.FirstLayerConfig,
        secondLayerConfig: exports.SecondLayerConfig,
    }),
]);
/** Configuration of the entire consent UI */
exports.UIConfiguration = t.union([
    exports.UIConfigurationBannerOnly,
    exports.UIConfigurationModalOnly,
    exports.UIConfigurationBannerIntoModal,
]);
//# sourceMappingURL=consentUiConfiguration.js.map